"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getValuesCreator = getValuesCreator;
var _utils = require("../../utils");
function getValuesCreator(getState) {
  const {
    formElement,
    inputStates
  } = getState();
  return inputNames => {
    return (0, _utils.getValues)(formElement, inputNames ? (0, _utils.getInputsWithNames)(inputStates, inputNames) : inputStates);
  };
}